export const GET_SURVEY_ID = "GET_SURVEY_ID"
export const CLEAR_SURVEY_ID = "CLEAR_SURVEY_ID"
export const UPDATE_LOADING_ANSWER_SURVEY = "UPDATE_LOADING_ANSWER_SURVEY"
export const GET_ANSWER_SURVEY = "GET_ANSWER_SURVEY"